/**
 * @flow weak
 */

import { call, put, select, takeLatest } from 'redux-saga/effects';
import Config from 'config';

import request from '../../lib/request';
import { getListingId } from '../listing/getters';
import { getUserId } from '../session/getters';

import { CHANGE_LOCALE_SUCCESS, LOCAL_STORAGE_LOCALE, loadLocale } from '../locale/actions';

export const SESSION_INIT = 'SESSION_INIT';
export const SESSION_FETCH_SUCCESS = 'SESSION_FETCH_SUCCESS';
export const SESSION_FETCH_ERROR = 'SESSION_FETCH_ERROR';
export const SESSION_FETCH_WISHLIST_PENDING = 'SESSION_FETCH_WISHLIST_PENDING';
export const SESSION_FETCH_WISHLIST_ERROR = 'SESSION_FETCH_WISHLIST_ERROR';
export const SESSION_FETCH_WISHLIST_SUCCESS = 'SESSION_FETCH_WISHLIST_SUCCESS';

//-----------------------------------------------------------------------------
// Actions
//-----------------------------------------------------------------------------

export const getWishlist = () => {
  return {
    type: SESSION_FETCH_WISHLIST_PENDING
  };
};

export function requestUser() {
  // Can refactor this block below into a re-useable
  // fetch function, that pulls the token before hand
  const options = {
    credentials: 'include'
  };

  return request(`${Config.api.base}/current_user/exchange`, options)
    .then(res => res.json());
}

//-----------------------------------------------------------------------------
// rootSagas - watchers
//-----------------------------------------------------------------------------

// On app startup, dispatch event to pull token from multiverse
export function* sessionTokenInit() {
  yield put({ type: SESSION_INIT });
}

export function* sessionSetup() {
  yield takeLatest(SESSION_INIT, fetchUser);
}

export function* sessionWishlist() {
  yield takeLatest(SESSION_FETCH_WISHLIST_PENDING, fetchWishlist);
}


//-----------------------------------------------------------------------------
// Sagas
//-----------------------------------------------------------------------------

export function* fetchWishlist() {
  function requestFollowing(userId: string, listingId: string) {
    const options = { credentials: 'include' };
    return request(`${Config.api.base}/wishlists?user_id=${userId}&listing_id=${listingId}&include=none`, options)
      .then(res => res.json());
  }

  try {
    const userId = yield select(getUserId);
    const listingId = yield select(getListingId);
    if (userId && listingId) {
      const data = yield requestFollowing(userId, listingId);

      yield put({ type: SESSION_FETCH_WISHLIST_SUCCESS, payload: data.wishlists[0] });
    }
  }
  catch (e) {
    yield put({ type: SESSION_FETCH_WISHLIST_ERROR, e });
  }
}


export function* fetchUser() {
  try {
    // If there is no logged in user, don't request the session data
    if (!document.cookie.split('; ').includes('logged_in=true')) {
      throw new Error('unnecessary request to fetch user session');
    }

    const data = yield call(requestUser);

    // Server returned { 'error': 'unauthorized' }
    if (data.error || !data.current_user) {
      throw new Error('unauthorized request to fetch user session');
    }

    yield put({ type: SESSION_FETCH_SUCCESS, payload: {
      user: data.current_user,
      csrfToken: sessionStorage.getItem('csrf_token')
    }});
  }
  catch (e) {
    console.log(e);
    yield put({ type: SESSION_FETCH_ERROR });

    // We're NOT LOGGED IN - try to set locale from localStorage
    if (localStorage.getItem(LOCAL_STORAGE_LOCALE)) {
      const localeToUse = localStorage.getItem(LOCAL_STORAGE_LOCALE);
      const data = yield loadLocale(localeToUse);
      yield put({ type: CHANGE_LOCALE_SUCCESS, messages: data.messages, locale: data.locale });
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/session/actions.js